import { render, staticRenderFns } from "./CjgDetail.vue?vue&type=template&id=059112d9&scoped=true&"
import script from "./CjgDetail.vue?vue&type=script&lang=js&"
export * from "./CjgDetail.vue?vue&type=script&lang=js&"
import style0 from "./CjgDetail.vue?vue&type=style&index=0&id=059112d9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "059112d9",
  null
  
)

component.options.__file = "CjgDetail.vue"
export default component.exports